import {
  ExternalPhoneNumberDto,
  ExternalPhoneNumberSearchQueryDto,
  ImportExternalPhoneNumberDto,
  PhoneNumber,
  PurchasePhoneNumberDto
} from 'shared/interfaces/Telephony';
import { axiosBaseInstance } from 'shared/utils/axios-instances';

const telephonyBaseUrl = '/telephony';

export const TelephonyService = {
  getNumbers: async (): Promise<PhoneNumber[]> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${telephonyBaseUrl}/phone-numbers`
    });

    return response.data;
  },

  deleteNumber: async (phoneNumberId: string): Promise<void> => {
    await axiosBaseInstance({
      method: 'delete',
      url: `${telephonyBaseUrl}/phone-numbers/${phoneNumberId}`
    });
  },

  importExternalPhoneNumber: async (importPhoneNumberDto: ImportExternalPhoneNumberDto): Promise<PhoneNumber> => {
    const response = await axiosBaseInstance({
      method: 'post',
      url: `${telephonyBaseUrl}/external-phone-numbers/import`,
      data: importPhoneNumberDto
    });

    return response.data;
  },

  purchasePhoneNumber: async (purchasePhoneNumberDto: PurchasePhoneNumberDto): Promise<PhoneNumber> => {
    const response = await axiosBaseInstance({
      method: 'post',
      url: `${telephonyBaseUrl}/external-phone-numbers/purchase`,
      data: purchasePhoneNumberDto
    });

    return response.data;
  },

  getExternalPhoneNumbers: async (
    externalPhoneNumberSearchQueryDto: ExternalPhoneNumberSearchQueryDto
  ): Promise<ExternalPhoneNumberDto[]> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${telephonyBaseUrl}/external-phone-numbers`,
      params: externalPhoneNumberSearchQueryDto
    });

    return response.data;
  }
};
